var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 13.9993C28.0025 14.4095 27.8778 14.8105 27.6426 15.1465C27.4074 15.4825 27.0733 15.7369 26.6868 15.8743L18.7568 18.7581L15.8743 26.6868C15.7323 27.0696 15.4765 27.3997 15.1413 27.6328C14.8061 27.8659 14.4076 27.9909 13.9993 27.9909C13.5911 27.9909 13.1926 27.8659 12.8574 27.6328C12.5222 27.3997 12.2664 27.0696 12.1243 26.6868L9.24184 18.7568L1.31184 15.8743C0.929088 15.7323 0.598982 15.4765 0.365871 15.1413C0.132761 14.8061 0.0078125 14.4076 0.0078125 13.9993C0.0078125 13.5911 0.132761 13.1926 0.365871 12.8574C0.598982 12.5222 0.929088 12.2664 1.31184 12.1243L9.24184 9.24184L12.1243 1.31184C12.2664 0.929088 12.5222 0.598982 12.8574 0.365871C13.1926 0.132761 13.5911 0.0078125 13.9993 0.0078125C14.4076 0.0078125 14.8061 0.132761 15.1413 0.365871C15.4765 0.598982 15.7323 0.929088 15.8743 1.31184L18.7581 9.24184L26.6868 12.1243C27.0733 12.2617 27.4074 12.5161 27.6426 12.8522C27.8778 13.1882 28.0025 13.5892 27.9993 13.9993Z",
    fill: "url(#paint0_linear_668_864)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_864",
    x1: 0.0078125,
    y1: 27.9909,
    x2: 33.1905,
    y2: 10.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5644C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmiration);
export default __webpack_public_path__ + "static/media/Admiration.3295ce5ac67b0a92e0bd9ad2313e6080.svg";
export { ForwardRef as ReactComponent };